import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setDischargeField,
  addDischargeArrayItem,
  removeDischargeArrayItem,
} from "../../../../Redux/actions/dischargeActions";

const AVAILABLE_INSTRUCTIONS = [
  { instrCode: "INS001", instrName: "Take prescribed medications regularly." },
  { instrCode: "INS002", instrName: "Complete full course of antibiotics." },
  { instrCode: "INS003", instrName: "Maintain personal hygiene." },
  { instrCode: "INS004", instrName: "Monitor temperature daily." },
  { instrCode: "INS005", instrName: "Avoid self medication." },
  { instrCode: "INS006", instrName: "Return to hospital if symptoms worsen." },
];

export default function PatientInstructions() {
  const dispatch = useDispatch();
  const selectedInstructions = useSelector(
    (state) => state.discharge?.dischargePatientInstruction || []
  );
  const additionalInstruction = useSelector(
    (state) => state.discharge?.additionalInstruction || ""
  );

  const isChecked = (instrCode) => {
    return selectedInstructions.some((item) => item.instrCode === instrCode);
  };

  const handleToggleInstruction = (instr) => {
    const existingIndex = selectedInstructions.findIndex(
      (item) => item.instrCode === instr.instrCode
    );

    if (existingIndex > -1) {
      dispatch(removeDischargeArrayItem("dischargePatientInstruction", existingIndex));
    } else {
      dispatch(
        addDischargeArrayItem("dischargePatientInstruction", {
          instructionId: selectedInstructions.length + 1,
          instrCode: instr.instrCode,
          instrName: instr.instrName,
          status: 1,
        })
      );
    }
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-2 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        9. Patient Instructions ({selectedInstructions.length} Selected)
      </h3>
      <label className="block text-xs font-semibold mb-2 text-gray-700">
        Standard Instructions
      </label>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2.5 gap-x-3 mb-3 text-xs font-medium text-gray-700">
        {AVAILABLE_INSTRUCTIONS.map((instr) => {
          const checked = isChecked(instr.instrCode);
          return (
            <label
              key={instr.instrCode}
              className="flex items-center gap-2 cursor-pointer hover:text-teal-800 transition"
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => handleToggleInstruction(instr)}
                className="rounded text-teal-600 focus:ring-teal-500"
              />
              <span className={checked ? "text-teal-900 font-semibold" : ""}>
                {instr.instrName}
              </span>
            </label>
          );
        })}
      </div>
      <div>
        <label className="block text-xs font-semibold mb-1 text-gray-700">
          Additional Instructions
        </label>
        <input
          type="text"
          value={additionalInstruction}
          onChange={(e) =>
            dispatch(setDischargeField("additionalInstruction", e.target.value))
          }
          className="w-full text-xs border border-gray-200 rounded-md px-3 py-2 outline-none focus:border-teal-500 transition"
          placeholder="e.g. Maintain adequate hydration and follow the prescribed medication schedule."
        />
      </div>
    </div>
  );
}
